import axios from 'axios';

export async function validateDriverAddress(address) {
  const res = await axios.post(
    `/validateDriverAddress`,
    { address },
  );
  return res.data;
}

export async function saveSessionDriverAddressConfirmation() {
  const res = await axios.post(
    `/session-validate-address`
  );
  return res.data;
}
